import audace from '../assets/harmony/audace.jpg';
import collectif from '../assets/harmony/collectif.jpg';
import communication from '../assets/harmony/communication.jpg';
import confiance from '../assets/harmony/confiance.jpg';
import creativite from '../assets/harmony/creativite.jpg';
import critique from '../assets/harmony/critique.jpg';
import curiosite from '../assets/harmony/curiosite.jpg';
import empathie from '../assets/harmony/empathie.jpg';
import entreprendre from '../assets/harmony/entreprendre.jpg';
import intelligenceEmotionnelle from '../assets/harmony/ie.jpg';
import motivation from '../assets/harmony/motivation.jpg';
import presence from '../assets/harmony/presence.jpg';
import resolution from '../assets/harmony/resolution.jpg';
import stress from '../assets/harmony/stress.jpg';
import temps from '../assets/harmony/temps.jpg';
import vision from '../assets/harmony/vision.jpg';

export const harmonyPalette = [
  '#071B45',
  '#212E57',
  '#4D597A',
  '#636E8B',
  '#808AA3',
  '#969FB3',
  '#C0C5CF',
  '#D4D7DD',
];

export const getHarmonyRankStyle = (index: number) => ({
  backgroundColor: harmonyPalette[index % harmonyPalette.length],
  color: index % harmonyPalette.length < 4 ? '#FFFFFF' : '#000B33',
});

export const harmonyImages: Record<string, string> = {
  'carte_resolution_problemes.png': resolution,
  'carte_confiance.png': confiance,
  'carte_intelligence_emotionnelle.png': intelligenceEmotionnelle,
  'carte_empathie.png': empathie,
  'carte_communication.png': communication,
  'carte_gestion_temps.png': temps,
  'carte_gestion_stress.png': stress,
  'carte_creativite.png': creativite,
  'carte_esprit_entreprendre.png': entreprendre,
  'carte_audace.png': audace,
  'carte_motivation.png': motivation,
  'carte_vision.png': vision,
  'carte_presence.png': presence,
  'carte_sens_du_collectif.png': collectif,
  'carte_curiosite.png': curiosite,
  'carte_esprit_critique.png': critique,
};
